import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import Moment from 'moment-timezone';
import Vue from 'vue';
import TranslationService from '../../../services/translation.service';
import templateMarkup from 'raw-loader!./grid-widget.html';
import VyTable from '../../../vueComponents/table/src/table.vue';

class GridWidget {
    constructor(params) {
        var self = this;
        self.params = params;
        self.isFirstCall = true;

        self.widgetSignals = params.widgetSignals;

        self.showEdit = params.showEdit;

        self.translationService = new TranslationService();

        self.subscriptions = [];
        self.observableOptions = params.observableOptions;
        self.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.panelHeaderHeight = params.panelHeaderHeight;
        self.headerVisible = params.headerVisible;
        self.headerSizingClass = ko.pureComputed(function() {
            return ko.unwrap(self.headerVisible) ? 'headerSizing' : '';
        });

        self.dataLoaded = ko.observable(false);

        if (self.widgetSignals && self.widgetSignals.dataRequested) {
            self.widgetSignals.dataRequested.dispatch();
        }

        self.id = _.get(self.observableOptions(), 'id');

        self.divId = "t" + self.id;
        self.selectionEnabled = ko.observable(false);

        self.selectedCount = ko.observable(0);

        self.rows = ko.observableArray();
        self.updating = false;

        self.numberOfRows = function () {
            return _.get(ko.unwrap(self.rows), 'length', 0);
        };

        self.headers = ko.observableArray();
        self.currentPage = ko.observable();
        self.maxCount = ko.observable(0);
        self.totalPages = ko.observable(1);
        self.pageSize = 10;

        if (self.observableOptions()) {
            self.pageSize = _.get(self.observableOptions(), 'pageSize', 10);

            if (_.get(self.observableOptions(), 'pageNum')) {
                self.currentPage(self.observableOptions().pageNum);
            }
            else {
                _.set(self.observableOptions(), 'pageNum', 1);
                self.currentPage(1);
            }
        }

        self.RefreshData();

        self.subscriptions.push(self.observableData.subscribe(function () {
            self.DataUpdated();
        }));
    }

    koDescendantsComplete() {
        let self = this;
        self.subscriptions.push(self.observableData.subscribe(function () {
            if (self.resolve) {
                self.resolve({
                    last_page: self.totalPages(),
                    data: convertRowsToTabular(self.rows())
                });
                self.updating = false;
                self.resolve = undefined;
            }
            if (!self.vueTable) {
                let data = self.observableData();
                let columns = self.getColumnsFromData(data);
                let persistenceID = `vyopta_cpma_table_${self.id}`;
                // set initial sort
                let options = self.observableOptions();
                let sortIndex = options.sortIndex;
                let sortAsc = options.sortAsc;
                let column = columns[sortIndex - (data.sortIndexOffset || 0)];
                if (column) {
                    column.sort = (sortAsc ? 'asc' : 'desc');
                }
                let reloadData = 1;

                let autoFetchConfig = {
                    // this url isn't actually used since we're overriding tabulator's ajax functionality, but it's required to trigger the data load
                    url: '',
                    ajaxRequestFunc: (url, config, tableParams) => {
                        self.updating = true;
                        let data = self.observableData(); // UI-2438: need to unwrap observablData each request because it may have changed
                        let options = self.observableOptions();
                        let optionsChanged = false;
                        // check if sorting needs to be updated
                        if (tableParams.sorters && tableParams.sorters.length > 0) {
                            let sorter = tableParams.sorters[0];
                            let sortIndex;
                            self.getColumnsFromData(data).forEach(function(column, index) {
                                if (column.field === sorter.field) {
                                    sortIndex = index + (data.sortIndexOffset || 0); // convert from zero to one based if needed
                                }
                            });
                            if (options.sortIndex !== sortIndex) {
                                options.sortIndex = sortIndex;
                                options.sortAsc = sorter.dir === 'asc' ? true : false;
                                optionsChanged = true;
                            } else if ((sorter.dir === 'asc') !== options.sortAsc) {
                                options.sortAsc = sorter.dir === 'asc' ? true : false;
                                optionsChanged = true;
                            }
                        } else {
                          if (options.sortIndex !== undefined && options.sortIndex - (data.sortIndexOffset || 0) !== -1) { // no sorters in table so remove from options if there
                              delete options.sortIndex;
                              delete options.sortAsc;
                              optionsChanged = true;
                          }
                        }
                        // check if page needs to be updated
                        if (options.pageNum !== tableParams.page) {
                            options.pageNum = tableParams.page;
                            optionsChanged = true;
                        }
                        return new Promise((resolve, reject) => {
                            if (optionsChanged) {
                                self.resolve = resolve;
                                self.observableOptions(options);
                                if (self.widgetSignals && self.widgetSignals.optionsSignal) {
                                    self.widgetSignals.optionsSignal.dispatch(options);
                                }
                            } else {
                                resolve({
                                    last_page: self.totalPages(),
                                    data: convertRowsToTabular(self.rows())
                                });
                                self.updating = false;
                            }
                        });
                    }
                };
                let childAutoFetchConfig = {
                  // this url isn't actually used since we're overriding tabulator's ajax functionality, but it's required to trigger the data load
                    url: '',
                    ajaxRequestFunc: function(url, config, tableParams) {
                        // this function works in concert with rowExpanded
                        let subTable = this.table;
                        let row = config.parent.getData();
                        let rowEl = config.parent.getElement();
                        let innerTable = row.innerTable;
                        let sorter;
                        let sortStr;
                        if (tableParams.sorters && tableParams.sorters.length > 0) {
                            sorter = tableParams.sorters[0];
                            let sortField = sorter.field.replace('_', '.');
                            sortStr = sortField + ' ' + (sorter.dir === 'asc' ? 'ASC' : 'DESC');
                        }
                        let page = tableParams.page;
                        return new Promise((resolve, reject) => {
                            row._loadInnerRows(page, sortStr).then(function(result) {
                                rowEl.querySelector('.tabulator-footer').hidden = innerTable.totalPages() < 2;

                                let columns = innerTable.displayCols().map((columnKey, index) => {
                                  let field = columnKey.replace('.', '_');
                                  let result = {
                                    field: field,
                                    formatter: 'html',
                                    title: innerTable.headers()[index]
                                  };

                                  // UI-2508: Since we have to call subTable.setColumns, the existing sorting state is lost,
                                  //          so we have to modify the initial sort direction to be descending for the relevant
                                  //          column in the case where the user has triggered a sort.
                                  if (sorter && sorter.field === field && sorter.dir === 'asc') {
                                    result.headerSortStartingDir = 'desc';
                                  }

                                  return result;
                                });
                                subTable.setColumns(columns.splice(1));

                                resolve({
                                    last_page: innerTable.totalPages(),
                                    data: convertRowsToTabular(innerTable.rows())
                                });
                            })
                        });
                    }
                };
                if (data.innerRowDisplayIndex) {
                    self.childColumns = [{ field: 'id'}];
                }

                self.vueTable = new Vue({
                    el: '#gridWidgetVueContainer-' + self.id,
                    data: function() {
                        return {
                            columns,
                            persistenceID,
                            autoFetchConfig,
                            childAutoFetchConfig,
                            reloadData,
                            childColumns: self.childColumns,
                            rowExpanded: self.rowExpanded.bind(self),
                            editColumns: self.editColumns.bind(self),
                            showEdit: self.showEdit,
                        };
                    },
                    components: {
                        'vy-table': VyTable
                    },
                    methods: {
                      handlePersistenceUpdated: function(id, type, data) {
                          if (type === 'columns') {
                              let options = self.observableOptions();
                              if (options.panelHeader) {
                                return; // don't change dashboard panels
                              }
                              let newDisplayDetail = data.map(column => column.field.replace('_', '.'));
                              // only update if different
                              if (newDisplayDetail.length > 1
                                  && options.displayDetail
                                  && options.displayDetail.length === newDisplayDetail.length
                                  && !options.displayDetail.every((val, index) => val === newDisplayDetail[index])) {
                                options.displayDetail = newDisplayDetail;
                                // send update upstream
                                self.observableOptions(options);
                                if (self.widgetSignals && self.widgetSignals.optionsSignal) {
                                    self.widgetSignals.optionsSignal.dispatch(options);
                                }
                              }
                          }
                      }
                    }
                });
                self.vueTable.reloadData++; // trigger a reload of table data
            }
        }));
    }

    getColumnsFromData(data) {
        let columns = [];
        if (data.tabulatorColumns) {
            columns = data.tabulatorColumns;
        } else if (data.displayDetail && data.colOptionsDetail && data.colOptionsDetail.length > 0) {
            columns = this.getColumnsWithOptions(data);
        } else if (data.headers && data.headers.length > 0 && data.rowProperties && data.rowProperties.length > 0) {
            columns = this.getColumnsFromHeaders(data);
        }
        return columns;
    }

    getColumnsWithOptions(data) {
        let columns = [];
        data.displayDetail.forEach(function(columnName, index) {
            let columnOption = data.colOptionsDetail.filter(option => option.name === columnName)[0];
            if (columnOption) {
                let column = {
                  field: columnOption.name.replace('.', '_'),
                  formatter: 'html', // ideally remove but first need to change types of html columns
                  minWidth: columnOption.minWidth || 100,
                  title: columnOption.title,
                  type: columnOption.type,
                };
                if (columnOption.tooltip) {
                    column.tooltip = columnOption.tooltip;
                }
                columns.push(column);
            }
        });
        return columns;
    }

    getColumnsFromHeaders(data) {
        let columns = [];
        columns = data.headers.map(function(header, index) {
            let column = {
              field: data.rowProperties[index].replace('.', '_'),
              formatter: 'html',
              minWidth: data.widths[index] || 100,
              title: header,
            };
            if (!data.actionIndexes || data.actionIndexes.indexOf(index) > -1) {
                column.cellClick = function(e, cell) {
                    cell.getData()._actionCallback(index);
                    cell.getRow().reformat();
                };
            }
            if (column.title === "Edit") {
                column.headerSort = false;
            }
            return column;
        });
        return columns;
    }

    editColumns() {
        let self = this;
        if (self.widgetSignals && self.widgetSignals.optionsPanelOpen) {
            self.widgetSignals.optionsPanelOpen.dispatch();
        }
    }
    rowExpanded(row, subTable) {
        let rowEl = row.getElement();
        rowEl.querySelector('.tabulator-footer').hidden = true;
        subTable.setPage(1);
    }

    sanitize(colHtml) {
        // only need to remove possible xss from strings
        if (typeof colHtml === 'string') {
            // jquery parseHTML removes scripts, possibly remove on* triggers too in the future
            return $('<div>').append($.parseHTML(colHtml)).html();
        }
        return colHtml;
    }

    RefreshData() {
        var self = this;
        var data = self.observableData();

        if (data && data.rows) {
            self.selectionEnabled(!!data.selectionEnabled);

            if (data.headers) {
                self.headers(data.headers);
            }

            self.maxCount(parseInt(data.maxCount, 10) || 0);
            self.totalPages(Math.ceil(self.maxCount() / self.pageSize));

            if (self.totalPages() > 0 && self.currentPage() > self.totalPages()) {
                _.set(self.observableOptions(), 'pageNum', 1);
                self.currentPage(1);
                self.observableOptions.valueHasMutated();
            }

            self.rows(data.rows);
            self.dataLoaded((!!data.rows));

            if (self.dataLoaded() && self.widgetSignals) {
                self.widgetSignals.dataLoaded.dispatch();
            }
            let columns = self.getColumnsFromData(data);
            if (self.vueTable && !isSameColumns(columns, self.vueTable.columns)) {
                self.vueTable.columns = columns;
            }
            if (self.vueTable && !self.updating) {
                self.vueTable.reloadData++; // trigger a reload of table data
            }
        }
    }

    DataUpdated() {
        var self = this;
        self.RefreshData();
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
        if (self.vueTable) {
            self.vueTable.$destroy();
            self.vueTable.$el.parentNode.removeChild(self.vueTable.$el);
        }

    }
}

function convertRowsToTabular(rows) {
    return rows.map((row) => {
        let result = {};
        Object.keys(row).forEach(function(key) {
            result[key.replace('.', '_')] = row[key];
        });
        return result;
    });
}

function isSameColumns(cols1, cols2) {
  if (cols1.length !== cols2.length) {
    return false;
  }

  let cols1Clone = _.cloneDeep(cols1);
  let cols2Clone = _.cloneDeep(cols2);

  function sortFunc(a, b) {
    return a.field < b.field ? -1 : 1;
  }

  cols1Clone.sort(sortFunc);
  cols2Clone.sort(sortFunc);

  return cols1Clone.every((col, i) => {
    return col.field === cols2Clone[i].field;
  });
}

export default { viewModel: GridWidget, template: templateMarkup };
